import { useEffect, useState } from 'react';

export const useIsOnline = () => {
  const [isOnline, setIsOnline] = useState<boolean>(true);

  const checkStatus = () => {
    setIsOnline(window.navigator.onLine);
  };

  useEffect(() => {
    checkStatus();
    window.addEventListener('online', checkStatus);
    window.addEventListener('offline', checkStatus);
    return () => {
      window.removeEventListener('online', checkStatus);
      window.removeEventListener('offline', checkStatus);
    };
  }, []);
  return { isOnline };
};
